module.exports = __webpack_public_path__ + "static/media/FENGYUN 2H.daf878ab.czml";